import React from 'react'
import { useCurrentLocale } from '../../src/contexts/CurrentLanguageContext'
import { HelpQuestionFragment } from '../../src/model/fragments'
import { getLocale } from '../../src/model/locale'
import { getHelpQuestionLink } from '../../src/model/urls'
import { CollapsibleProps } from '../Collapsible'
import { CollapsibleList } from '../CollapsibleList'
import { Content } from '../Content'

export interface QuestionListProps {
	questions: HelpQuestionFragment[]
}
export const QuestionList: React.FC<QuestionListProps> = ({ questions }) => {
	const locale = useCurrentLocale()
	return (
		<CollapsibleList
			items={questions.map((question) => { 
				const data = getLocale(question.locales, [locale]);

				return data && data.link && ({
					label: data.title,
					content: (
						<Content content={data.content} viewQuestionOrCareerList />
					),
					linkProps: data.link
						? getHelpQuestionLink(locale, question.id, data.link.url)
						: undefined,
				})
			}).filter(q => q) as Omit<CollapsibleProps, "large">[]}
			large
		/>
	)
}
